<template>
  <v-card class="elevation-0">
    <v-card-title>
      <span class="headline" v-if="showHeader">Earnings And Deductions</span>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" label="Search Here"></v-text-field>
    </v-card-title>
    <v-card-text>
      <v-data-table :items="items" :headers="headers" :search="search">
        <template v-slot:item.actions="{ item }">
          <v-btn icon text @click.stop="edit(item)" v-if="userAccess.edit >= 1">
            <v-icon color="info">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon text v-if="userAccess.delete >= 1">
            <v-icon color="error" @click.stop="deleteItem(item)"
              >mdi-delete</v-icon
            >
          </v-btn>
        </template>
        <template v-slot:item.alloType="{ item }">
          <v-radio-group column v-model="item.alloType" disabled>
            <v-radio label="None" :value="0"></v-radio>
            <v-radio label="Deminimis" :value="1"></v-radio>
            <v-radio label="Salary" :value="2"></v-radio>
          </v-radio-group>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- <v-dialog v-model="editDialog">
      <v-card>
        <v-card-title>
          <span class="headline">Edit</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" class="pb-0 mb-0">
              <v-text-field label="Code" :class="classPadding" v-model="ed.code"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-text-field label="Description" :class="classPadding" v-model="ed.desc"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" md="6" :class="classPadding">
              <v-select
                label="Type"
                :loading="typeCodeLoading"
                :items="typeCode"
                item-text="descrp"
                item-value="typeCD"
                :class="classPadding"
                v-model="ed.type"
                clearable
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-radio-group v-model="typeGroup" row :class="classPadding">
                <v-radio label="Earning" value="EARNTYPE"></v-radio>
                <v-radio label="Deduction" value="DEDUTYPE"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row v-if="company.showNonVATEcola">
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-radio-group v-model="nonVATEcola" column :class="classPadding">
                <v-radio
                  label="Non-Taxable (Include these earnings in the PME report field for Non-Taxable)"
                  :value="0"
                ></v-radio>
                <v-radio
                  label="E-Cola PME Field (Include these earnings in the PME report field for E-Cola)"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Fixed Allowance (Include these earnings in the PME report field for Fixed Allowance)"
                  :value="3"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
              <v-radio-group v-model="alloType" column :class="classPadding">
                <v-radio
                  label="Deminimis (Include these earnings in the Masterlists field for Deminimis)"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Salary (Include these earnings in the Masterlists field for Salary)"
                  :value="2"
                ></v-radio>
                <v-radio label="None (Exclude these earnings in the Masterlists field)" :value="0"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>-->
  </v-card>
</template>
<script>
import { mapActions } from "vuex";
import EventBus from "../../../../events/eventBus";
import userAccessMixin from "../../../../mixins/userAccessMixin";
const API_ENDPOINT = "/api/earnDeduc";
export default {
  props: {
    showHeader: {
      default: false,
      type: Boolean,
    },
  },
  mixins: [userAccessMixin],
  data: () => ({
    search: "",
    items: [],
    headers: [
      {
        text: "",
        value: "actions",
        sortable: false,
      },
      {
        text: "Code",
        value: "code",
        sortable: true,
      },
      {
        text: "Description",
        value: "description",
        sortable: true,
      },
      {
        text: "Type",
        value: "groupTypeDesc",
        sortable: true,
      },
      {
        text: "Tag",
        value: "alloType",
        sortable: false,
      },
    ],
    loading: false,
    selectedType: "Earnings",
    ed: {},
    typeCode: [],
    typeCodeLoading: false,
    typeGroup: "EARNTYPE",
    alloType: 0,
    nonVATEcola: 0,
    editDialog: false,
    classPadding: "my-0 py-0",
  }),
  methods: {
    ...mapActions("earningDeduction", ["select"]),
    getByType(type) {
      this.$axios
        .get(`${API_ENDPOINT}/${type}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getAll() {
      this.$axios
        .get(`${API_ENDPOINT}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    edit(item) {
      this.select(item);
      this.$router.push(`/earnings-deduction/edit/${item.code}`);
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete",
      }).then((res) => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/${item.code}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.getByType(this.selectedType);
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
  },
  created() {
    //this.getAll();
    this.getUserAccessRights("EarnDeducS");
    this.getByType(this.selectedType);
  },
  mounted() {
    EventBus.$on("SELECTED_TYPEGROUP", (type) => {
      this.selectedType = type;
      this.getByType(type);
    });
  },
};
</script>
